const __vite__mapDeps=(i,m=__vite__mapDeps,d=(m.f||(m.f=["./popup-age-verification.script-global-BGsXPZ3P.js","./index-DHaxRrJP.js","./popup-countdown-promo.script-global-D6Yw_46K.js","./popup-product-quickview.script-global-DOJMIJU9.js","./popup-promo.script-global-BgYq5jZt.js","./popup-sign-up.script-global-Bgg5zIhP.js","./section-main-collection.script-global-BdIFPIPZ.js","./customElements-q5d-b-jb.js","./index-ClDZ2u-n.js","./index-BaEy46h7.js","./each-DSCw-kmU.js","./index-CYwsQLH8.js","./cart-free-shipping.script-global-CFpaQVLW.js","./currency-select-CLIUcVup.js","./index-CyiqC18s.js","./language-select-BUf5wf3F.js","./menu-hamburger.script-global-BveQdEDA.js","./menu-horizontal.script-global-CRIR1z__.js","./predictive-search-BIWzOD1S.js","./share-BrMY-csw.js","./video-C3clfJP1.js","./address-form-uxFiUSNt.js","./pickup-availability-list-Cstt_yPj.js","./product-recommendations.script-DU8Oem7O.js"])))=>i.map(i=>d[i]);
var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
const scriptRel = "modulepreload";
const assetsURL = function(dep, importerUrl) {
  return new URL(dep, importerUrl).href;
};
const seen = {};
const __vitePreload = function preload(baseModule, deps, importerUrl) {
  let promise = Promise.resolve();
  if (deps && deps.length > 0) {
    let allSettled2 = function(promises) {
      return Promise.all(
        promises.map(
          (p) => Promise.resolve(p).then(
            (value) => ({ status: "fulfilled", value }),
            (reason) => ({ status: "rejected", reason })
          )
        )
      );
    };
    const links = document.getElementsByTagName("link");
    const cspNonceMeta = document.querySelector(
      "meta[property=csp-nonce]"
    );
    const cspNonce = (cspNonceMeta == null ? void 0 : cspNonceMeta.nonce) || (cspNonceMeta == null ? void 0 : cspNonceMeta.getAttribute("nonce"));
    promise = allSettled2(
      deps.map((dep) => {
        dep = assetsURL(dep, importerUrl);
        if (dep in seen) return;
        seen[dep] = true;
        const isCss = dep.endsWith(".css");
        const cssSelector = isCss ? '[rel="stylesheet"]' : "";
        const isBaseRelative = !!importerUrl;
        if (isBaseRelative) {
          for (let i = links.length - 1; i >= 0; i--) {
            const link2 = links[i];
            if (link2.href === dep && (!isCss || link2.rel === "stylesheet")) {
              return;
            }
          }
        } else if (document.querySelector(`link[href="${dep}"]${cssSelector}`)) {
          return;
        }
        const link = document.createElement("link");
        link.rel = isCss ? "stylesheet" : scriptRel;
        if (!isCss) {
          link.as = "script";
        }
        link.crossOrigin = "";
        link.href = dep;
        if (cspNonce) {
          link.setAttribute("nonce", cspNonce);
        }
        document.head.appendChild(link);
        if (isCss) {
          return new Promise((res, rej) => {
            link.addEventListener("load", res);
            link.addEventListener(
              "error",
              () => rej(new Error(`Unable to preload CSS for ${dep}`))
            );
          });
        }
      })
    );
  }
  function handlePreloadError(err) {
    const e = new Event("vite:preloadError", {
      cancelable: true
    });
    e.payload = err;
    window.dispatchEvent(e);
    if (!e.defaultPrevented) {
      throw err;
    }
  }
  return promise.then((res) => {
    for (const item of res || []) {
      if (item.status !== "rejected") continue;
      handlePreloadError(item.reason);
    }
    return baseModule().catch(handlePreloadError);
  });
};
const groupGlobalModules = /* @__PURE__ */ Object.assign({ "../groups/footers/footer/footer.script-global.ts": () => __vitePreload(() => import("./footer.script-global-Dn2KGOVq.js"), true ? [] : void 0, import.meta.url), "../groups/popups/popup-age-verification/popup-age-verification.script-global.ts": () => __vitePreload(() => import("./popup-age-verification.script-global-BGsXPZ3P.js"), true ? __vite__mapDeps([0,1]) : void 0, import.meta.url), "../groups/popups/popup-countdown-promo/popup-countdown-promo.script-global.ts": () => __vitePreload(() => import("./popup-countdown-promo.script-global-D6Yw_46K.js"), true ? __vite__mapDeps([2,1]) : void 0, import.meta.url), "../groups/popups/popup-product-quickview/popup-product-quickview.script-global.ts": () => __vitePreload(() => import("./popup-product-quickview.script-global-DOJMIJU9.js"), true ? __vite__mapDeps([3,1]) : void 0, import.meta.url), "../groups/popups/popup-promo/popup-promo.script-global.ts": () => __vitePreload(() => import("./popup-promo.script-global-BgYq5jZt.js"), true ? __vite__mapDeps([4,1]) : void 0, import.meta.url), "../groups/popups/popup-sign-up/popup-sign-up.script-global.ts": () => __vitePreload(() => import("./popup-sign-up.script-global-Bgg5zIhP.js"), true ? __vite__mapDeps([5,1]) : void 0, import.meta.url) });
Object.values(groupGlobalModules).forEach((module) => module());
const sectionsGlobalModules = /* @__PURE__ */ Object.assign({});
Object.values(sectionsGlobalModules).forEach((module) => module());
const pagesGlobalModules = /* @__PURE__ */ Object.assign({ "../pages/product/main-product/main-product.script-global.ts": () => __vitePreload(() => import("./main-product.script-global-CPV6a2t8.js"), true ? [] : void 0, import.meta.url), "../pages/product/snippets/product-info-content/product-info-content.script-global.ts": () => __vitePreload(() => import("./product-info-content.script-global-B5okas_s.js"), true ? [] : void 0, import.meta.url), "../pages/search-filters/main-collection/section-main-collection.script-global.ts": () => __vitePreload(() => import("./section-main-collection.script-global-BdIFPIPZ.js"), true ? __vite__mapDeps([6,7,8,9,10,1,11]) : void 0, import.meta.url) });
Object.values(pagesGlobalModules).forEach((module) => module());
const attrBoolean = {
  get: (element, attr) => {
    if (element.getAttribute(attr) === "false") {
      return false;
    }
    return element.hasAttribute(attr);
  },
  set: (element, attr, value) => {
    if (value) {
      element.setAttribute(attr, "");
    } else {
      element.removeAttribute(attr);
    }
  }
};
function DOMLoaded(callback) {
  if (/comp|inter/.test(document.readyState)) {
    callback();
  } else if ("addEventListener" in document) {
    document.addEventListener("DOMContentLoaded", callback);
  } else {
    document.attachEvent("onreadystatechange", () => {
      if (document.readyState === "complete") {
        callback();
      }
    });
  }
}
const isMobile = {
  android: !!navigator.userAgent.match(/Android/i),
  blackBerry: !!navigator.userAgent.match(/BlackBerry/i),
  ipad: !!navigator.userAgent.match(/iPad/i),
  iOS: !!navigator.userAgent.match(/iPhone|iPad|iPod/i),
  opera: !!navigator.userAgent.match(/Opera Mini/i),
  windows: !!navigator.userAgent.match(/Windows Phone/i),
  amazonePhone: !!navigator.userAgent.match(/(?:SD4930UR|\\bSilk(?:.+)Mobile\\b)/i),
  amazoneTablet: !!navigator.userAgent.match(/Silk/i),
  any: !!navigator.userAgent.match(/Android|BlackBerry|iPhone|iPad|iPod|Opera Mini|Windows Phone|(?:SD4930UR|\bSilk(?:.+)Mobile\b)|Silk/i)
};
class Device {
  constructor() {
    __publicField(this, "isMobile", null);
    __publicField(this, "isSafari", null);
  }
  mobile() {
    if (this.isMobile === null) {
      this.isMobile = isMobile.any;
    }
    return this.isMobile;
  }
  desktop() {
    return !this.mobile();
  }
  safari() {
    if (this.isSafari === null) {
      this.isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    }
    return this.isSafari;
  }
}
const device = new Device();
DOMLoaded(() => {
  const htmlEl = document.documentElement;
  if (device.mobile()) {
    htmlEl.classList.add("is-mobile");
    attrBoolean.set(htmlEl, "xo-is-mobile", true);
  } else {
    htmlEl.classList.add("is-desktop");
    attrBoolean.set(htmlEl, "xo-is-desktop", true);
  }
});
function createStore() {
  let checked = false;
  const storageAvailable = () => {
    if (!checked) {
      checked = true;
      const item = "@xoLocalStorageCheck";
      try {
        window.localStorage.setItem(item, item);
        window.localStorage.removeItem(item);
        return true;
      } catch {
        return false;
      }
    }
    return true;
  };
  const createStorage = () => {
    if (storageAvailable()) {
      return window.localStorage;
    }
    return {
      getItem() {
        return null;
      },
      setItem() {
      },
      removeItem() {
      },
      clear() {
      },
      key() {
        return null;
      },
      length: 0
    };
  };
  const storage2 = createStorage();
  return storage2;
}
const storage = createStore();
const ACTIVE = "xo-active";
const handlePasswordToggle = () => {
  const togglePasswords = document.querySelectorAll("#togglePassword");
  if (togglePasswords.length === 0) {
    return;
  }
  togglePasswords.forEach((togglePassword) => {
    var _a;
    const passwordField = (_a = togglePassword.previousElementSibling) == null ? void 0 : _a.querySelector('input[type="password"]');
    const eyeOpenPassword = togglePassword.querySelector(".xo-icon-open");
    const eyeHidePassword = togglePassword.querySelector(".xo-icon-hidden");
    if (!passwordField || !eyeOpenPassword || !eyeHidePassword) {
      return;
    }
    togglePassword.addEventListener("click", () => {
      const isPasswordField = passwordField.type === "password";
      passwordField.type = isPasswordField ? "text" : "password";
      if (isPasswordField) {
        eyeOpenPassword.classList.add(`${ACTIVE}`);
        eyeHidePassword.classList.add(`${ACTIVE}`);
      } else {
        eyeOpenPassword.classList.remove(`${ACTIVE}`);
        eyeHidePassword.classList.remove(`${ACTIVE}`);
      }
    });
  });
};
DOMLoaded(() => {
  handlePasswordToggle();
});
const snippetModules = /* @__PURE__ */ Object.assign({ "../snippets/action-scroll/action-scroll.script-global.ts": () => __vitePreload(() => import("./action-scroll.script-global-Bxca-FL-.js"), true ? [] : void 0, import.meta.url), "../snippets/cart/cart-free-shipping/cart-free-shipping.script-global.ts": () => __vitePreload(() => import("./cart-free-shipping.script-global-CFpaQVLW.js"), true ? __vite__mapDeps([12,7,8,9,10,1,11]) : void 0, import.meta.url), "../snippets/collection-list/collection-list-6/collection-list-6.script-global.ts": () => __vitePreload(() => import("./collection-list-6.script-global-C__33kN0.js"), true ? [] : void 0, import.meta.url), "../snippets/currency-select/currency-select.ts": () => __vitePreload(() => import("./currency-select-CLIUcVup.js"), true ? __vite__mapDeps([13,14,11,10,1]) : void 0, import.meta.url), "../snippets/image-banner/image-banner-3/image-banner-3.script-global.ts": () => __vitePreload(() => import("./image-banner-3.script-global-BWtk8fb-.js"), true ? [] : void 0, import.meta.url), "../snippets/language-select/language-select.ts": () => __vitePreload(() => import("./language-select-BUf5wf3F.js"), true ? __vite__mapDeps([15,14,11,10,1]) : void 0, import.meta.url), "../snippets/menu/menu-hamburger/menu-hamburger.script-global.ts": () => __vitePreload(() => import("./menu-hamburger.script-global-BveQdEDA.js"), true ? __vite__mapDeps([16,14,11,10,1]) : void 0, import.meta.url), "../snippets/menu/menu-horizontal/menu-horizontal.script-global.ts": () => __vitePreload(() => import("./menu-horizontal.script-global-CRIR1z__.js"), true ? __vite__mapDeps([17,10]) : void 0, import.meta.url), "../snippets/predictive-search/predictive-search.ts": () => __vitePreload(() => import("./predictive-search-BIWzOD1S.js"), true ? __vite__mapDeps([18,9]) : void 0, import.meta.url), "../snippets/predictive-search/types.ts": () => __vitePreload(() => Promise.resolve().then(() => types), true ? void 0 : void 0, import.meta.url), "../snippets/product-card/product-card/product-card.script-global.ts": () => __vitePreload(() => import("./product-card.script-global-C9y_Xodd.js"), true ? [] : void 0, import.meta.url), "../snippets/section-attr/section-attr.global.ts": () => __vitePreload(() => Promise.resolve().then(() => sectionAttr_global), true ? void 0 : void 0, import.meta.url), "../snippets/share/share.ts": () => __vitePreload(() => import("./share-BrMY-csw.js"), true ? __vite__mapDeps([19,14,11,10,1,8,9]) : void 0, import.meta.url), "../snippets/transform-list/transform-list.script-global.ts": () => __vitePreload(() => import("./transform-list.script-global-fyUZXBJB.js"), true ? [] : void 0, import.meta.url), "../snippets/transform-pill/transform-pill.script-global.ts": () => __vitePreload(() => import("./transform-pill.script-global-DEVMplhY.js"), true ? [] : void 0, import.meta.url), "../snippets/video/video.ts": () => __vitePreload(() => import("./video-C3clfJP1.js"), true ? __vite__mapDeps([20,7,8,9,10,1,11]) : void 0, import.meta.url) });
Object.values(snippetModules).forEach((module) => module());
const pageModules = /* @__PURE__ */ Object.assign({ "../pages/addresses/snippets/address-form/address-form.ts": () => __vitePreload(() => import("./address-form-uxFiUSNt.js"), true ? __vite__mapDeps([21,14,11,10,1,9]) : void 0, import.meta.url), "../pages/product/main-product/main-product.script-global.ts": () => __vitePreload(() => import("./main-product.script-global-CPV6a2t8.js"), true ? [] : void 0, import.meta.url), "../pages/product/snippets/pickup-availability-list/pickup-availability-list.ts": () => __vitePreload(() => import("./pickup-availability-list-Cstt_yPj.js"), true ? __vite__mapDeps([22,14,11,10,1]) : void 0, import.meta.url), "../pages/product/snippets/product-info-content/product-info-content.script-global.ts": () => __vitePreload(() => import("./product-info-content.script-global-B5okas_s.js"), true ? [] : void 0, import.meta.url), "../pages/product/snippets/product-recommendations/product-recommendations.script.ts": () => __vitePreload(() => import("./product-recommendations.script-DU8Oem7O.js"), true ? __vite__mapDeps([23,14,11,10,1,8,9]) : void 0, import.meta.url), "../pages/search-filters/main-collection/section-main-collection.script-global.ts": () => __vitePreload(() => import("./section-main-collection.script-global-BdIFPIPZ.js"), true ? __vite__mapDeps([6,7,8,9,10,1,11]) : void 0, import.meta.url) });
Object.values(pageModules).forEach((module) => module());
const SELECTORS = {
  PRICE: ".xo-price__item",
  COMPARE_AT_PRICE: ".xo-price__item.xo-price__item--del",
  BUTTON_ADD: ".shopify-payment-button__add",
  BUTTON_ADD_TEXT: ".xo-btn__text"
};
function updatePrice(targetProductId, price) {
  const priceEls = document.querySelectorAll(`xo-product[xo-product-id="${targetProductId}"] ${SELECTORS.PRICE}`);
  priceEls.forEach((priceEl) => {
    priceEl.innerHTML = price;
  });
}
function updateCompareAtPrice(targetProductId, price) {
  const compareAtPriceEls = document.querySelectorAll(`xo-product[xo-product-id="${targetProductId}"] ${SELECTORS.COMPARE_AT_PRICE}`);
  compareAtPriceEls.forEach((compareAtPriceEl) => {
    compareAtPriceEl.innerHTML = price;
  });
}
function soldOutMessage(targetProductId, message) {
  const buttonEls = document.querySelectorAll(`xo-product[xo-product-id="${targetProductId}"] ${SELECTORS.BUTTON_ADD}`);
  buttonEls.forEach((buttonEl) => {
    const btnTextEl = buttonEl.querySelector(SELECTORS.BUTTON_ADD_TEXT);
    if (btnTextEl) {
      btnTextEl.innerHTML = message;
    }
    buttonEl.style.pointerEvents = "none";
  });
}
window.WSPR = window.WSPR || {};
window.WSPR.updatePrice = updatePrice;
window.WSPR.updateCompareAtPrice = updateCompareAtPrice;
window.WSPR.soldOutMessage = soldOutMessage;
const types = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null
}, Symbol.toStringTag, { value: "Module" }));
const sectionAttr_global = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null
}, Symbol.toStringTag, { value: "Module" }));
export {
  DOMLoaded as D,
  attrBoolean as a,
  device as d,
  storage as s
};
